const constants = {
  BOXES_PER_ROW: 4,
  INITIAL_VALUE: 100,
};

export default constants;



// WEBPACK FOOTER //
// ./src/config/constants.js